import { api } from "../api";

/* ---------------- FETCH TEMPLATE ---------------- */
export const fetchTemplate = async (templateURL: string) => {
  try {
    const res = await api.get("/api/fetch-user-template", {
      params: { templateURL },
    });
    if (res.status === 200) {
      return res.data.template;
    }
  } catch (err: any) {
    console.error(
      "FetchingUserTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- CREATE TEMPLATE ---------------- */
export const createTemplate = async (
  templateType: string,
  templatePremadeType: string
) => {
  try {
    const res = await api.post("/api/create-new-template", {
      templateTypeInput: templateType,
      templatePremadeTypeInput: templatePremadeType,
    });
    if (res.status === 201) {
      return res.data;
    }
  } catch (err: any) {
    console.error(
      "CreateUserTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- SAVE DOC AS TEMPLATE ---------------- */
export const saveDocAsTemplate = async (
  name: string,
  doc: any[],
  signerLabels?: Record<string, string>,
  templateKind?: "template" | "quicksend",
  roles?: Array<{ key: string; label: string; fieldIds: string[] }>,
  senderFields?: Array<{ fieldId: string; label: string; type: string }>
) => {
  try {
    const res = await api.post("/api/save-doc-as-template", {
      name,
      doc,
      signerLabels: signerLabels ?? {},
      templateKind: templateKind ?? "template",
      roles: roles ?? [],
      senderFields: senderFields ?? [],
    });
    if (res.status === 201) return res.data;
  } catch (err: any) {
    console.error(
      "SaveDocAsTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- SAVE ENVELOPE AS TEMPLATE ---------------- */
export const saveEnvelopeAsTemplate = async (
  contractURL: string,
  name?: string
) => {
  try {
    const res = await api.post("/api/save-envelope-as-template", {
      contractURL,
      name,
    });
    if (res.status === 201) return res.data;
  } catch (err: any) {
    console.error(
      "SaveEnvelopeAsTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- UPDATE TEMPLATE ---------------- */
export const updateTemplate = async (
  templateURL: string,
  data: { name?: string; doc?: any[]; signerLabels?: Record<string, string> }
) => {
  try {
    const res = await api.patch("/api/update-template", { templateURL, ...data });
    if (res.status === 200) return res.data;
  } catch (err: any) {
    console.error(
      "UpdateTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- RENAME TEMPLATE ---------------- */
export const renameTemplate = async (templateURL: string, newTitle: string) => {
  try {
    const res = await api.post("/api/rename-template", {
      templateURL,
      newTitle,
    });
    if (res.status === 200) return res.data;
  } catch (err: any) {
    console.error(
      "RenameUserTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};

/* ---------------- DELETE TEMPLATE ---------------- */
export const deleteTemplate = async (templateURL: string) => {
  try {
    const res = await api.post("/api/delete-template", { templateURL });
    if (res.status === 200) return res.data;
  } catch (err: any) {
    console.error(
      "DeleteUserTemplateFailed",
      err.response?.data || err.message
    );
    return null;
  }
};
